export default __webpack_public_path__ + "static/media/1.5ce9f2ba.jpg";